import "@fontsource-variable/manrope";
import "@fontsource-variable/bricolage-grotesque";
import "maplibre-gl/dist/maplibre-gl.css";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
import { registerSW } from "virtual:pwa-register";

registerSW({
  immediate: true,
  onOfflineReady() {
    window.dispatchEvent(new CustomEvent("velosud:offline-ready"));
  },
  onNeedRefresh() {
    window.dispatchEvent(new CustomEvent("velosud:update-ready"));
  },
});

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
